import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-science",
  "use": "icon-science-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-science\"><rect x=\"6\" y=\"28\" width=\"36\" height=\"14\" rx=\"4\" stroke=\"currentColor\" stroke-width=\"3\" /><path d=\"M20 7H10C7.79086 7 6 8.79086 6 11V17C6 19.2091 7.79086 21 10 21H20\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" /><circle cx=\"34\" cy=\"14\" r=\"8\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" /><circle cx=\"34\" cy=\"14\" r=\"3\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol